<template lang="pug">
.c-canlendar
  article-section(title="年度計畫"
    :article="article")
</template>

<script>
import ArticleSection from "@/components/ArticleSection.vue";

export default {
  name: "Calendar",
  components: {
    ArticleSection
  },
  data() {
    return {
      article: null
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const snap = await this.$f.db
        .collection("articles")
        .doc("calendar")
        .get();
      this.article = this.$u.parseDbSnap(snap);
    }
  }
};
</script>
